import { PropsWithChildren, forwardRef } from 'react';
import { TriggerButton } from './TriggerButton';
import { TriggerProps } from '../types';
import { LoadingTriggerButton } from './LoadingTriggerButton';

export const ConditionTriggerButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<TriggerProps>
>((props, ref) => <TriggerButton innerRef={ref} {...props} />);

export const GhostTriggerButton = ({ ...props }: PropsWithChildren<TriggerProps>) => (
  <TriggerButton isGhost {...props} />
);

export const ConditionLoadingTriggerButton = () => <LoadingTriggerButton />;
